import styled from '@emotion/styled'

const StyledFileList = styled.div`
  display: flex;
  overflow: auto;
  height: 100%;
  width: 100%;
  background: #fff;
  border-radius: 4px 4px 0 0;
  padding-top: 44px;
  flex-wrap: wrap;
  align-content: flex-start;
  > div {
    width: 20%;
    min-width: 200px;
    margin-bottom: 44px;
  }
`
const StyledFileDetail = styled.div`
  /* column-count: 2;
  column-gap: 40px; */
  column-gap: 10px;
  display: flex;
  width: 100%;
  overflow: auto;
  height: 100%;
  padding: 14px 120px 0;
  border-radius: 4px 4px 0 0;
  flex-wrap: wrap;
  .item-width {
    width: 49%;
  }
  .list-item {
    background: #fff;
    margin-bottom: 14px;
    border-radius: 4px;
    height: min-content;
  }
`
export { StyledFileList, StyledFileDetail }
